<template>
  <v-container fluid>
    <!-- Background Decorative Elements -->
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <v-row align="stretch">
      <!-- Main Welcome Card -->
      <v-col cols="12" md="8">
        <v-card 
          elevation="24"           
          class="welcome-card overflow-hidden position-relative rounded-xl"
        >
          <!-- Gradient Overlay -->
          <div class="gradient-overlay"></div>
          
          <v-row no-gutters align="center" class="position-relative">
            <v-col cols="12" md="6" class="welcome-text-section">
              <div class="pa-6 ml-2">
                <div class="welcome-badge mb-4">
                  <v-chip 
                    color="rgba(255,255,255,0.2)" 
                    text-color="white" 
                    label
                    class="glass-chip"
                  >
                    <v-icon left small>mdi-account-heart</v-icon>
                    HR Management System
                  </v-chip>
                </div>
                
                <h1 class="welcome-title mb-3">
                  Welcome Back!
                </h1>
                
                <h2 class="department-title mb-4">
                  สำนักอำนวยการ<br>
                  <span class="highlight-text">กลุ่มงานจัดการบุคคล</span>
                </h2>
                
                <div class="feature-tags">
                  <v-chip 
                    v-for="(tag, index) in ['Modern', 'Efficient', 'Secure']" 
                    :key="index"
                    small 
                    outlined 
                    color="white"
                    class="mr-2 mb-2 glass-chip-small"
                    :style="{ animationDelay: `${index * 0.2}s` }"
                  >
                    {{ tag }}
                  </v-chip>
                </div>
              </div>
            </v-col>
            
            <v-col cols="12" md="6" class="image-section">
              <div class="pa-4">
                <div class="image-container">
                  <v-img
                    class="main-image animate__animated animate__fadeInRight"
                    src="hrovec.png"
                    height="250px"
                    contain
                  ></v-img>
                  
                  <!-- Floating Icons -->
                  <div class="floating-icon icon-1">
                    <v-icon color="white" size="20">mdi-account-group</v-icon>
                  </div>
                  <div class="floating-icon icon-2">
                    <v-icon color="white" size="20">mdi-chart-line</v-icon>
                  </div>
                  <div class="floating-icon icon-3">
                    <v-icon color="white" size="20">mdi-shield-check</v-icon>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- Login Card -->
      <v-col cols="12" md="4">
        <v-card 
          class="login-card h-100 rounded-xl" 
          elevation="20"          
        >
          <div class="login-content text-center pa-8">
            <!-- Logo Section -->
            <div class="logo-section mb-6">
              <div class="logo-background">
                <v-img
                  class="animate__animated animate__zoomIn logo-image"
                  src="hrvec.png"
                  height="80px"
                  contain
                ></v-img>
              </div>
            </div>

            <!-- Welcome Message -->
            <div class="login-message mb-6">
              <h3 class="login-title mb-2">เข้าสู่ระบบ</h3>
              <p class="login-subtitle">ยินดีต้อนรับสู่ระบบกลุ่มงานจัดการบุคคล</p>
            </div>

            <!-- Login Button -->
            <v-btn 
              to="/pages/login"             
              size="large"
              class="login-btn elevation-8 rounded-xl"
              block
            >
              <lord-icon
                src="https://cdn.lordicon.com/kdduutaw.json"
                trigger="hover"
                stroke="bold"
                colors="primary:#FFFFFF,secondary:#FFFFFF"
                style="width: 32px; height: 32px; margin-right: 8px"
              ></lord-icon>
              เข้าสู่ระบบ
            </v-btn>

            <!-- Quick Stats -->
            <div class="quick-stats mt-8">
              <v-row>
                <v-col cols="6" class="text-center">
                  <div class="stat-item">
                    <v-icon color="primary" size="24" class="mb-1">mdi-account-multiple</v-icon>
                    <div class="stat-number">{{ periods.length || '---' }}</div>
                    <div class="stat-label">Periods</div>
                  </div>
                </v-col>
                <v-col cols="6" class="text-center">
                  <div class="stat-item">
                    <v-icon color="success" size="24" class="mb-1">mdi-check-circle</v-icon>
                    <div class="stat-number">100%</div>
                    <div class="stat-label">Uptime</div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "OcsMasterWelcome",
  data() {
    return {
      ApiKey: "mouovec2024",
      periods: []
    };
  },
  async mounted() {
    await this.periodQuery();
  },
  methods: {
    async periodQuery() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey
        });
        this.periods = result.data;
      } catch (error) {
        console.error('Error fetching periods:', error);
      }
    }
  }
};
</script>

<style scoped>

/* Floating Background Shapes */
.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 70%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 60px;
  height: 60px;
  top: 30%;
  right: 30%;
  animation-delay: 4s;
}

.shape-4 {
  width: 100px;
  height: 100px;
  bottom: 10%;
  left: 20%;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.main-content {
  position: relative;

}

/* Welcome Card Styles */
.welcome-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.welcome-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, 
    rgba(102, 126, 234, 0.1) 0%, 
    rgba(118, 75, 162, 0.1) 100%);
  pointer-events: none;
}

.welcome-text-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  min-height: 350px;
  display: flex;
  align-items: center;
}

.welcome-badge {
  animation: fadeInUp 1s ease-out;
}

.glass-chip {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.welcome-title {
  font-size: 3rem;
  font-weight: 800;
  background: linear-gradient(45deg, #ffffff, #f0f0f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.department-title {
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.3;
  animation: fadeInUp 1s ease-out 0.4s both;
}

.highlight-text {
  background: linear-gradient(45deg, #ffd700, #ffed4e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
}

.feature-tags {
  animation: fadeInUp 1s ease-out 0.6s both;
}

.glass-chip-small {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  animation: slideInLeft 1s ease-out both;
}

/* Image Section */
.image-section {
  background: rgba(255, 255, 255, 0.02);
}

.image-container {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-image {
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));
}

.floating-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s infinite;
}

.icon-1 {
  top: 20%;
  right: 20%;
  animation-delay: 0s;
}

.icon-2 {
  bottom: 30%;
  left: 10%;
  animation-delay: 0.5s;
}

.icon-3 {
  top: 60%;
  right: 10%;
  animation-delay: 1s;
}

/* Login Card Styles */
.login-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.login-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo-section {
  animation: bounceIn 1s ease-out;
}

.logo-background {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
}

.logo-background::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  animation: shimmer 3s linear infinite;
}

.logo-image {
  position: relative;
  z-index: 1;
}

.login-message {
  animation: fadeInUp 1s ease-out 0.3s both;
}

.login-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
}

.login-subtitle {
  color: #7f8c8d;
  margin: 0;
}

.login-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  text-transform: none;
  font-size: 1.1rem;
  padding: 16px 32px;
  transition: all 0.3s ease;
  animation: fadeInUp 1s ease-out 0.5s both;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(102, 126, 234, 0.4);
}

/* Quick Stats */
.quick-stats {
  animation: fadeInUp 1s ease-out 0.7s both;
}

.stat-item {
  padding: 16px;
  border-radius: 12px;
  background: rgba(102, 126, 234, 0.05);
  transition: all 0.3s ease;
}

.stat-item:hover {
  background: rgba(102, 126, 234, 0.1);
  transform: translateY(-2px);
}

.stat-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
}

.stat-label {
  font-size: 0.85rem;
  color: #7f8c8d;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .welcome-title {
    font-size: 2.2rem;
  }
  
  .department-title {
    font-size: 1.2rem;
  }
  
  .welcome-text-section {
    min-height: 250px;
  }
  
  .login-content {
    padding: 24px !important;
  }
  
  .logo-background {
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 600px) {
  .welcome-title {
    font-size: 1.8rem;
  }
  
  .department-title {
    font-size: 1rem;
  }

  
  .pa-2 {
    padding: 8px !important;
  }
}
</style>